export const addStatusQuery = (router, status) => {
  const { replace, pathname, query } = router;
  replace({ pathname, query: { ...query, ...status } }, undefined, {
    shallow: true,
  });
};
